import { render, staticRenderFns } from "./AddPet.vue?vue&type=template&id=1156e852&scoped=true"
import script from "./AddPet.vue?vue&type=script&lang=js"
export * from "./AddPet.vue?vue&type=script&lang=js"
import style0 from "./AddPet.vue?vue&type=style&index=0&id=1156e852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1156e852",
  null
  
)

export default component.exports